import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import FunnelPage from "@/pages/FunnelPage";
import AdminPage from "@/pages/AdminPage";
import AgencyPage from "@/pages/AgencyPage";
import ResetPage from "@/pages/ResetPage";
import LifemasteryPage from "@/pages/LifemasteryPage";

const isAgencyDomain = window.location.hostname.includes("rockymountainwebsites");
const isLifeWorksDomain = window.location.hostname.includes("thrivebeyondservice");

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={isLifeWorksDomain ? <ResetPage /> : isAgencyDomain ? <AgencyPage /> : <FunnelPage />} />
          <Route path="/info" element={<LandingPage />} />
          <Route path="/agency" element={<AgencyPage />} />
          <Route path="/reset" element={<ResetPage />} />
          <Route path="/lifemastery" element={<LifemasteryPage />} />
          <Route path="/admin" element={<AdminPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster richColors position="top-center" />
    </div>
  );
}

export default App;
